import React from "react";

const NotFound = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f8fafc",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          textAlign: "center",
          maxWidth: "450px",
          width: "100%",
        }}
      >
        <div
          style={{
            fontSize: "70px",
            marginBottom: "10px",
          }}
        >
          😕
        </div>

        <h1
          style={{
            fontSize: "32px",
            margin: "0 0 10px",
            color: "#1f2937",
          }}
        >
          Oops!
        </h1>

        <h2
          style={{
            fontSize: "22px",
            margin: "0 0 15px",
            color: "#ef4444",
            fontWeight: "600",
          }}
        >
          You seem to be lost
        </h2>

        <p
          style={{
            color: "#6b7280",
            fontSize: "16px",
            lineHeight: "1.6",
            marginBottom: "25px",
          }}
        >
          The page you're looking for doesn't exist or has been moved.
        </p>

        <button
          onClick={() => (window.location.href = "/")}
          style={{
            background: "#2563eb",
            color: "#fff",
            border: "none",
            padding: "12px 28px",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "16px",
            fontWeight: "600",
          }}
        >
          Go Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;